<template>
  <BlockContainer>
    <BlockTileStack
      class="margin-override"
      @positionItems="stackInit = true"
      :stack="stories"
    >
      <template v-slot:default="slotProps">
        <StoryTile
          v-for="({ title, thumbnailImage, slug }, i) in stories"
          :key="i"
          :title="title"
          :slug="slug"
          :image="thumbnailImage"
          @load="slotProps.handleLoad()"
          class="p-grid w-1/2"
        />
      </template>
    </BlockTileStack>
    <BlockLazyLoadMore @loadMore="handleLoadMore" :end="end" v-if="stackInit" />
  </BlockContainer>
</template>

<script>
import { getLatest } from "@io/story";
import { handleLoadMore } from "@io/helpers";
import { BlockContainer, BlockTileStack, BlockLazyLoadMore } from "@c/Block";
import StoryTile from "./StoryTile";

export default {
  name: "Stories",

  meta: {
    title: "Stories"
  },

  components: {
    BlockContainer,
    BlockTileStack,
    BlockLazyLoadMore,
    StoryTile
  },

  data: () => ({
    stories: null,
    loading: true,
    end: false,
    stackInit: false
  }),

  async created() {
    const stories = await getLatest({
      limit: 10
    });
    this.stories = Object.values(stories);
    await this.$nextTick();
    this.loading = false;
  },

  methods: {
    async handleLoadMore() {
      handleLoadMore.call(this, getLatest, 10, "stories");
    }
  }
};
</script>

<style scoped>
.p-grid {
  padding: 0.625rem;
}

::v-deep .margin-override div {
  margin-top: 0;
}
</style>
